define('ch_search',[
    'jquery',
    'semantic',
    'ch_selectors',
    'ch_utils',
    'ch_ga',
], function ($) {
    var $searchField;

    $.fn.search.settings.error.noResults = 'Press "enter" to search by keyword.';

    // Registers a custom templating function for Semantic Search
    $.fn.search.settings.templates.chTemplate = function (responses, fields) {
        var formatted = {
            categories: [],
            courses: [],
            schools: [],
        };
        var searchTerm = $searchField.search('get value');
        var html;

        // we only truly support one search form at a time
        // however it is possible to have multiple included on the page at once (such as in mobile)
        // so we defer to just the first one in the page
        if (Array.isArray(searchTerm)) {
            searchTerm = searchTerm[0];
        }

        responses.results.reduce(function (acc, response) {
            var value = response.value;
            var elem;

            if (searchTerm) {
                value = value.replace(new RegExp(preg_quote(searchTerm), 'gi'), '<strong>$&</strong>');
            }

            if (response.provider) {
                value = value + ' - <span class="provider">' + response.provider + '</span>';
            }

            elem = ''
                + '<li class="ui-menu-item">'
                + '<a class="ui-menu-item-wrapper result" data-type="' + response.section + '" href="' + response.url + '" >' + value + '</a>'
                + '</li>';

            if (response.section === 'Category') {
                acc.categories.push(elem);
            } else if (response.section === 'Course') {
                acc.courses.push(elem);
            } else if (response.section === 'School') {
                acc.schools.push(elem);
            }

            return acc;
        }, formatted);

        // Iterate the keys in the object formatted so we can reduce into a string
        html = Object.keys(formatted).reduce(function (acc, val) {
            var capitalized;
            if (formatted[val].length) {
                capitalized = val[0].toUpperCase() + val.slice(1);
                acc += '<li class="ui-autocomplete-section">' + capitalized + '</li>';
                acc += formatted[val].join('');
            }
            return acc;
        }, '');

        // If html is an empty string then there are no results to display
        if (html) {
            return '<ul class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front">'
                        + html
                    + '</ul>';
        }
        return false;
    };

    function searchByKeyword(keyword, hub, suggest) {
        keyword = $.trim(keyword);
        if (keyword.length <= 1) {
            return false;
        }

        Filters = {};
        Filters.kw = encodeURIComponent(keyword);
        Filters.suggest = suggest;
        Filters.hub = hub.toLowerCase();

        submitFiltersAndKeywordSearch();

        return false;
    }

    function submitFiltersAndKeywordSearch() {
        var uri = [];
        var path;

        if (Filters.kw) {
            uri.push('kw=' + Filters.kw);
        }

        if (Filters.suggest) {
            uri.push('suggest=true');
        }

        if (Filters.school || Filters.kw) {
            path = '/' + (Filters.hub ? Filters.hub : CH.Hub.uri) + '/classes';
        } else if (Filters.hub) {
            path = window.location.pathname.replace(('/' + CH.Hub.uri), '/' + Filters.hub);
        } else {
            path = window.location.pathname;
        }

        window.location.href = path + (uri.length > 0 ? ('?' + uri.join('&')) : '');
    }

    function initializeSearch() {
        var $searchForm = $('.js-search-form');
        $searchField = $('.js-search-by-keyword');

        $searchField.find('input').val(Filters.kw ? Filters.kw : '');

        $searchField.search({
            type: 'chTemplate', // Use our custom search result templating function
            apiSettings: {
                url: '/course/filter/search-suggestions?search={query}',
                data: {
                    maxrows: 10,
                },
                onResponse: function (response) {
                    ga(
                        'send',
                        'event',
                        'Search Tracking',
                        'Autocomplete Results Returned',
                        response.data.length + ' Results',
                        { nonInteraction: true }
                    );
                    return { results: response.data };
                },
            },
            minCharacters: 3,
        });

        $searchForm.on('click', '.ui-menu-item-wrapper', function () {
            ga(
                'send',
                'event',
                'Search Tracking',
                'Suggestion Selected',
                $(this).data('type'),
                { nonInteraction: false }
            );
        });

        $searchForm.on('focus', 'input', function() {
            ga(
                'send',
                'event',
                'Search Tracking',
                'Search Field Focused',
                null,
                { nonInteraction: false }
            );
        });

        $searchForm.on('submit', function (e) {
            var form = this;
            var keyword = form.search.value;
            var hub = '';

            if (form.hub) {
                hub = form.hub.value;
            }

            ga(
                'send',
                'event',
                'Search Tracking',
                'Keyword Submitted',
                form.search.value,
                { nonInteraction: false }
            );

            e.preventDefault();

            return searchByKeyword(
                keyword,
                hub,
                true
            );
        });
    }

    function initializeKeywordSearchLinks() {
        $('.js-keyword-search-link').on('click', function (e) {
            var data = $(this).data();

            e.preventDefault();

            searchByKeyword(
                data.keyword,
                data.hub,
                Object.prototype.hasOwnProperty.call(data, 'suggest') ? !!data.suggest : true
            );
        });
    }

    // initialize the view
    $(() => {
        if (!window.Filters) {
            window.Filters = {};
        }

        initializeSearch();
        initializeKeywordSearchLinks();
    });

    // return the module
    return {
        submit: submitFiltersAndKeywordSearch,
    };
});

